import React from 'react';
import { Container, Spinner, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FeedItem from './FeedItem';

const formatTableName = (tableName) => {
  return tableName
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const LoadingState = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
    <Spinner id='spinner' animation="grow" variant="light" />
  </div>
);

const ErrorState = ({ searchTerm }) => {
  const { t } = useTranslation('common');
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
      <div className="text-center" style={{ color: 'var(--text-primary)' }}>
        <h4>{t('common:noSearchResults', 'No search results found')}</h4>
      </div>
    </div>
  );
};

const EmptyState = () => {
  const { t } = useTranslation('common');
  return (
    <Container className="text-center py-5" style={{ color: 'var(--text-primary)' }}>
      <h4>{t('common:noContentAvailable', 'No content available')}</h4>
      <p style={{ color: 'var(--text-secondary)' }}>
        {t('common:tryAdjustingFilters', 'Try adjusting your search or filter criteria')}
      </p>
    </Container>
  );
};

const FeedItemsList = ({ data, schema, table, buttonName, feedName, branch, topic }) => (
  <>
    {data.map((item, index) => (
      <div key={item.id || index} className="mb-4">
        <FeedItem
          item={item}
          feedName={feedName || formatTableName(table)}
          branch={branch || ''}
          topic={topic || ''}
          buttonName={buttonName || 'Document'}
          schema={schema}
          table={table}
          expanded={false}
        />
      </div>
    ))}
  </>
);

const LoadMoreButton = ({ onLoadMore, loading }) => {
  const { t } = useTranslation('common');
  return (
    <div className="d-flex justify-content-center align-items-center py-4">
      <Button 
        className="clickable" 
        id="feedViewMoreButton" 
        onClick={onLoadMore}
        disabled={loading}
      >
        {loading ? <Spinner animation="grow" variant="light" size="sm" /> : t('common:more', 'More')}
      </Button>
    </div>
  );
};

const FeedPageContent = ({ 
  data, 
  loading, 
  error, 
  schema, 
  table, 
  onLoadMore,
  searchTerm,
  buttonName,
  feedName,
  branch,
  topic
}) => {
  // Only show full loading screen on INITIAL load (no data yet)
  if (loading && (!data || data.length === 0)) return <LoadingState />;
  if (error) return <ErrorState searchTerm={searchTerm} />;
  if (!data || data.length === 0) return <EmptyState />;

  return (
    <div className="feed-page-content" style={{ paddingTop: '15px' }}>
      <FeedItemsList 
        data={data} 
        schema={schema} 
        table={table} 
        buttonName={buttonName}
        feedName={feedName}
        branch={branch}
        topic={topic}
      />
      <LoadMoreButton onLoadMore={onLoadMore} loading={loading} />
      <div style={{ height: '100px' }} />

      <style>{`
        /* Match the Glance column width on the homepage so feed cards read as
           cards rather than full-width bars on wide desktop screens. */
        .feed-page-content {
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
          padding-left: 10px;
          padding-right: 10px;
          box-sizing: border-box;
        }
      `}</style>
    </div>
  );
};

export default FeedPageContent;